import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFormData } from 'Services/Features/Branch/branchSlice';
import { FormGroup, Label, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { Minus } from 'react-feather';

const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const OperationHoursForm = () => {
    const dispatch = useDispatch();
    const operationHoursState = useSelector((state) => state.branch.currentBranch.operation_hours);
    // console.log(operationHoursState, 'operationHoursState');
    const handleHoursChange = (day, field, value) => {
        const existingHours = operationHoursState[day] || "";

        let updatedTime = "";

        if (field === "open") {
            // Update jam buka
            const closeTime = existingHours.includes(" - ") ? existingHours.split(" - ")[1] : "";
            updatedTime = value + (closeTime ? " - " + closeTime : "");
        } else if (field === "close") {
            // Update jam tutup
            const openTime = existingHours.includes(" - ") ? existingHours.split(" - ")[0] : "";
            updatedTime = (openTime ? openTime + " - " : "") + value;
        }

        // Dispatch ke Redux
        dispatch(setFormData({
            operation_hours: {
                ...operationHoursState,
                [day]: updatedTime.trim()
            }
        }));
    };


    const normalizeHours = (hours, day) => {
        const timeRangeRegex = /^\d{2}:\d{2} - \d{2}:\d{2}$/;

        if (!timeRangeRegex.test(hours)) {
            // Update state jadi "close" kalau format salah
            dispatch(setFormData({
                operation_hours: {
                    ...operationHoursState,
                    [day]: "close"
                }
            }));
            return "close";
        }

        return hours;
    };

    const getHours = (hours, type, day) => {
        const normalizedHours = normalizeHours(hours, day);

        if (normalizedHours === "close") return null;        

        const [openTime, closeTime] = normalizedHours.split(" - ");

        return type === "open" ? openTime : closeTime;
    };




    const toggleDay = (day, isChecked) => {
        const updatedTime = isChecked ? "09:00 - 18:00" : "close";

        dispatch(setFormData({
            operation_hours: {
                ...operationHoursState,
                [day]: updatedTime
            }
        }));
    };



    return (
        <FormGroup>
            <Label for="validationOperationalHours" style={{ fontWeight: 'bold' }}>Jam Operasional :</Label>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '16px'
            }}>
                {daysOfWeek.map((day, index) => (
                    <div
                        key={day}
                        style={{
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'center',
                            // paddingRight: index % 3 !== 2 ? '16px' : '0',
                            // borderRight: index % 3 !== 2 ? '1px solid #eee' : 'none'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '120px', flexShrink: 0 }}>
                            <Input
                                className="checkbox_animated"
                                type='checkbox'
                                checked={operationHoursState[day] && operationHoursState[day] !== "close"}
                                onChange={(e) => toggleDay(day, e.target.checked)}
                            />
                            <Label style={{ whiteSpace: 'nowrap' }}>{day.charAt(0).toUpperCase() + day.slice(1)}</Label>
                        </div>
                        {operationHoursState[day] && operationHoursState[day] !== "close" && (
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <DatePicker
                                    selected={
                                        getHours(operationHoursState[day], 'open', day)
                                            ? new Date(`1970-01-01T${getHours(operationHoursState[day], 'open', day)}:00`)
                                            : null
                                    }                                    
                                    onChange={(date) => handleHoursChange(day, 'open', date ? date.toTimeString().slice(0, 5) : '')}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Open"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="form-control digits"
                                    // disabled={operationHoursState[day].closed}
                                    placeholderText="Pilih Jam Buka"
                                />
                                <Minus size={15} className="text-dark mt-2" />
                                <DatePicker
                                    selected={
                                        getHours(operationHoursState[day], 'close', day)
                                            ? new Date(`1970-01-01T${getHours(operationHoursState[day], 'close', day)}:00`)
                                            : null
                                    }                                    
                                    onChange={(date) => handleHoursChange(day, 'close', date ? date.toTimeString().slice(0, 5) : '')}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Close"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="form-control digits"
                                    // disabled={operationHoursState[day].closed}
                                    placeholderText="Pilih Jam Tutup"
                                />
                                {/* <Input
                                    type='checkbox'
                                    className="checkbox_animated"
                                    checked={operationHoursState[day].closed}
                                    onChange={(e) => handleHoursChange(day, 'closed', e.target.checked)}
                                /> Closed */}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </FormGroup>
    );
};

export default OperationHoursForm;